export const NAVIGATION_RAIL_DRAWERWIDTH = 88;
export const NAVIGATION_RAIL_LIST_DRAWERWIDTH = 86;
export const NAVIGATION_RAIL_SUB_DRAWERWIDTH = 240; // TODO: Ask UI team what this value should be
